import { render, staticRenderFns } from "./unionTroduc.vue?vue&type=template&id=1f466ae8&scoped=true&"
import script from "./unionTroduc.vue?vue&type=script&lang=js&"
export * from "./unionTroduc.vue?vue&type=script&lang=js&"
import style0 from "./unionTroduc.vue?vue&type=style&index=0&id=1f466ae8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f466ae8",
  null
  
)

export default component.exports